const styles = theme => ({
  root: {
    maxWidth: 385,
    minWidth: 300,
    margin: "2%",
    boxShadow: `2px 3px 18px rgba(0, 0, 0, .12)`,
    "& .MuiCardHeader-action": {
      margin: 0
    }
  },
  removeButton: {
    color: "#a2a2a2 !important"
  },
  title: {
    fontSize: 18,
    fontFamily: "'Poppins', 'sans-serif'",
    fontWeight: 700,
    color: theme.palette.primary.default
  },
  subheader: {
    fontSize: 12
  },
  image: {
    display: "block",
    margin: "0 auto",
    height: "350px"
  },
  video: {
    height: "auto"
  },
  expand: {
    transform: "rotate(0deg)",
    marginLeft: "auto",
    transition: theme.transitions.create("transform", {
      duration: theme.transitions.duration.shortest
    })
  },
  expandOpen: {
    transform: "rotate(180deg)"
  },
  avatar: {
    backgroundColor: theme.palette.primary.main
  },
  cardAction: {
    justifyContent: "space-between",
    alignItems: "flex-end",
    padding: theme.spacing(2)
  },
  expires: {
    "&> p": {
      color: theme.palette.primary.light,
      fontFamily: "'Poppins', 'sans-serif'"
    },
    "&> h3": {
      margin: 0
    }
  },
  expiresContent: {
    display: "flex",
    alignItems: "center"
  },
  errorIcon: {
    marginLeft: theme.spacing(0.5),
    color: theme.palette.warning.main,
    fontSize: 20
  },
  expiresDisplayText: {
    color: theme.palette.primary.default
  },
  actionButtons: {
    display: "flex",
    flexDirection: "column",
    "&> button": {
      width: 140,
      height: 36,
      fontWeight: 700
    },
    "&> button:nth-of-type(1)": {
      marginBottom: 6
    }
  },
  downloadButton: {
    backgroundColor: "#2FBBF0",
    color: [theme.palette.secondary.light, "!important"],
    "&:hover": {
      backgroundColor: "#2FBBF0"
    }
  },
  publishButton: {
    backgroundColor: theme.palette.primary.main,
    "&:hover": {
      backgroundColor: theme.palette.primary.main
    }
  },
  cardMedia: {
    position: "relative",
    display: "flex",
    justifyContent: "center"
  },
  iconContainer: {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
  },
  playIcon: {
    color: "#fff",
    fontSize: "100px"
  }
})

export default styles



// WEBPACK FOOTER //
// ./src/components/PostCard/styles.js